<template>
  <div class="page-container device-page">
    <!-- 统计卡片 -->
    <div class="stats-row">
      <div class="stat-item primary" @click="handleStatClick('total')">
        <div class="stat-item-value">{{ statistics.total || 0 }}</div>
        <div class="stat-item-label">设备总数</div>
      </div>
      <div class="stat-item success" @click="handleStatClick('normal')">
        <div class="stat-item-value">{{ statistics.normal || 0 }}</div>
        <div class="stat-item-label">正常设备</div>
      </div>
      <div class="stat-item danger" @click="handleStatClick('fault')">
        <div class="stat-item-value">{{ statistics.fault || 0 }}</div>
        <div class="stat-item-label">故障设备</div>
      </div>
      <div class="stat-item warning" @click="handleStatClick('nfcBound')">
        <div class="stat-item-value">{{ statistics.nfcBound || 0 }}</div>
        <div class="stat-item-label">已绑NFC</div>
      </div>
      <div class="stat-item purple" @click="handleStatClick('important')">
        <div class="stat-item-value">{{ statistics.important || 0 }}</div>
        <div class="stat-item-label">重要设备</div>
      </div>
    </div>

    <!-- 设备列表卡片 -->
    <div class="card">
      <div class="card-header">
        <div class="card-title-group">
          <span class="card-title">设备台账列表</span>
          <el-button
            type="text"
            icon="el-icon-pie-chart"
            @click="$router.push({ name: 'deviceStatisticsDashboard' })"
          >统计视图</el-button>
        </div>
        <div class="btn-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="handleAdd"
          >
            新增设备
          </el-button>
          <el-button
            type="success"
            size="small"
            icon="el-icon-upload2"
            @click="handleImport"
          >
            Excel导入
          </el-button>
          <!-- <el-button type="warning" size="small">云平台同步</el-button> -->
          <el-button
            size="small"
            icon="el-icon-download"
            @click="handleExport"
            :loading="exportLoading"
            :disabled="!tableData.length"
          >
            导出
          </el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            @click="handleBatchDelete"
            :loading="batchDeleteLoading"
            :disabled="!tableData.length"
          >
            批量删除
          </el-button>
        </div>
      </div>

      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-input
          v-model="queryForm.keyword"
          placeholder="设备编号/名称"
          clearable
          style="width: 180px"
          @keyup.enter.native="handleQuery"
        />
        <AreaCascader
          v-model="queryForm.areaId"
          :options="areaTree"
          placeholder="所属区域"
          clearable
          style="width: 180px"
          @change="handleQuery"
        />
        <el-select
          v-model="queryForm.systemId"
          placeholder="全部系统"
          clearable
          style="width: 150px"
          @change="handleSystemChange"
        >
          <el-option
            v-for="item in systemList"
            :key="item.uuid"
            :label="item.systemName"
            :value="item.uuid"
          ></el-option>
        </el-select>
        <el-select
          v-model="queryForm.deviceTypeId"
          placeholder="全部设施类型"
          clearable
          style="width: 140px"
          @change="handleQuery"
        >
          <el-option
            v-for="item in filteredTypeList"
            :key="item.uuid"
            :label="item.typeName"
            :value="item.uuid"
          ></el-option>
        </el-select>
        <el-select
          v-model="queryForm.deviceStatus"
          placeholder="全部状态"
          clearable
          style="width: 100px"
          @change="handleQuery"
        >
          <el-option label="正常" :value="0"></el-option>
          <el-option label="故障" :value="1"></el-option>
        </el-select>
        <el-select
          v-model="queryForm.hasNfc"
          placeholder="NFC状态"
          clearable
          style="width: 100px"
          @change="handleQuery"
        >
          <el-option label="已绑定" value="true"></el-option>
          <el-option label="未绑定" value="false"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">搜索</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
      <el-table
        :data="tableData"
        border
        stripe
        v-loading="loading"
        style="width: 100%"
        height="100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="deviceCode" label="设备编号" width="180">
          <template slot-scope="scope">
            <span
              class="table-code-link"
              @click.stop="handleView(scope.row)"
            >{{ scope.row.deviceCode }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deviceName" label="设备名称" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="systemName" label="消防系统" min-width="90"></el-table-column>
        <el-table-column prop="deviceTypeName" label="设施类型" min-width="90"></el-table-column>
        <el-table-column prop="areaPath" label="所属区域" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="installLocation" label="具体位置描述" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="install-location">{{ scope.row.installLocation || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deviceLevel" label="级别" width="60">
          <template slot-scope="scope">
            <span class="level-badge" :class="'level-' + (scope.row.deviceLevel || 'c').toLowerCase()">{{ scope.row.deviceLevel || 'C' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deviceStatus" label="状态" width="70">
          <template slot-scope="scope">
            <el-tag :type="scope.row.deviceStatus === 0 ? 'success' : 'danger'" size="small">
              {{ scope.row.deviceStatusName || (scope.row.deviceStatus === 0 ? '正常' : '故障') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="nfcTagId" label="NFC" width="70">
          <template slot-scope="scope">
            <span v-if="scope.row.nfcTagId" class="nfc-status bound">已绑定</span>
            <span v-else class="nfc-status unbound">未绑定</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" plain size="mini" @click="handleView(scope.row)">查看详情</el-button>
            <el-button type="warning" plain size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="danger" plain size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!-- 分页 -->
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <DeviceDialog
      :visible.sync="dialogVisible"
      :type="dialogType"
      :initial-data="currentEditDevice"
      :system-list="systemList"
      :type-list="typeList"
      :area-tree="areaTree"
      @success="loadData"
    />

    <!-- 详情弹窗 -->
    <DeviceDetailDialog
      :visible.sync="detailVisible"
      :device-data="currentDevice"
    />

    <!-- 导入弹窗 -->
    <ImportDeviceDialog
      :visible.sync="importVisible"
      @success="handleImportSuccess"
    />
  </div>
</template>

<script>
// 服务
import { areaService } from '@/features/gnmk/area/area.service';
import { deviceTypeService } from '@/features/gnmk/deviceType/deviceType.service';
import { deviceService } from './device.service';
// 工具函数
import { downloadFromApiBlobResponse } from '@/features/common/utils/downloadFileUtil.js';
// 组件
import DeviceDialog from './deviceDialog.vue';
import DeviceDetailDialog from './deviceDetailDialog.vue';
import ImportDeviceDialog from './importDeviceDialog.vue';
import AreaCascader from '@/features/gnmk/components/AreaCascader.vue';

export default {
  name: 'DeviceList',
  components: {
    DeviceDialog,
    DeviceDetailDialog,
    ImportDeviceDialog,
    AreaCascader
  },
  data () {
    return {
      // 统计数据
      statistics: {
        total: 0,
        normal: 0,
        fault: 0,
        nfcBound: 0,
        important: 0
      },
      // 查询表单
      queryForm: {
        keyword: '',
        systemId: '',
        deviceTypeId: '',
        areaId: '',
        deviceStatus: '',
        hasNfc: '',
        deviceLevel: ''
      },
      // 基础数据
      systemList: [],
      typeList: [],
      areaTree: [],
      // 表格数据
      tableData: [],
      loading: false,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      // 弹窗相关
      dialogVisible: false,
      dialogType: 'add',
      currentEditDevice: {},

      // 详情弹窗
      detailVisible: false,
      currentDevice: null,

      // 导入导出相关
      importVisible: false,
      exportLoading: false,
      batchDeleteLoading: false
    };
  },
  computed: {
    filteredTypeList () {
      if (!this.queryForm.systemId) return this.typeList;
      return this.typeList.filter(t => t.systemId === this.queryForm.systemId);
    }
  },
  mounted () {
    this.initData();
  },
  methods: {
    initData () {
      // 始终加载基础数据和列表数据
      this.loadBaseData();
      this.loadData();
      this.updateStatistics();
    },

    loadBaseData () {
      // 加载消防系统
      deviceTypeService.listFireSystems().then(res => {
        this.systemList = res.data || [];
      });
      // 加载设施类型
      deviceTypeService.listDeviceTypes().then(res => {
        this.typeList = res.data || [];
      });
      // 加载区域树
      areaService.getAreaTree().then(res => {
        this.areaTree = res.data || [];
      });
    },

    loadData () {
      this.loading = true;
      const params = {
        ...this.queryForm,
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize
      };
      deviceService.queryDevicePage(params).then(res => {
        const data = res.data;
        this.tableData = data.list || data.rows || [];
        this.pagination.total = data.total || 0;
      }).finally(() => {
        this.loading = false;
      });
    },

    updateStatistics () {
      deviceService.getDeviceStatistics().then(res => {
        const stats = res.data;
        if (stats) {
          this.statistics = stats;
        }
      });
    },

    handleStatClick (type) {
      // 保留结构性筛选条件(区域/系统/类型/关键字)，重置状态类筛选条件
      this.queryForm.deviceStatus = '';
      this.queryForm.hasNfc = '';
      this.queryForm.deviceLevel = '';

      switch (type) {
        case 'normal':
          this.queryForm.deviceStatus = 0;
          break;
        case 'fault':
          this.queryForm.deviceStatus = 1;
          break;
        case 'nfcBound':
          this.queryForm.hasNfc = 'true';
          break;
        case 'important':
          this.queryForm.deviceLevel = 'A';
          break;
        case 'total':
        default:
          // 已重置，不做处理
          break;
      }
      this.handleQuery();
    },

    handleQuery () {
      this.pagination.pageNo = 1;
      this.loadData();
      this.updateStatistics();
    },

    handleReset () {
      this.queryForm = {
        keyword: '',
        systemId: '',
        deviceTypeId: '',
        areaId: '',
        deviceStatus: '',
        hasNfc: '',
        deviceLevel: ''
      };
      this.handleQuery();
    },

    handleSystemChange () {
      this.queryForm.deviceTypeId = '';
      this.handleQuery();
    },

    handleAdd () {
      this.dialogType = 'add';
      this.currentEditDevice = {};
      this.dialogVisible = true;
    },

    handleEdit (row) {
      this.dialogType = 'edit';
      this.currentEditDevice = row;
      this.dialogVisible = true;
    },

    handleView (row) {
      this.currentDevice = row;
      this.detailVisible = true;
    },

    handleDelete (row) {
      this.$confirm(`确认删除设备"${row.deviceName}"吗？`, '提示', { type: 'warning' }).then(() => {
        this.loading = true;
        deviceService.deleteDevice(row.uuid).then(() => {
          this.$message.success('删除成功');
          this.loadData();
          // 刷新统计
          this.updateStatistics();
        }).finally(() => {
          this.loading = false;
        });
      }).catch(() => {});
    },

    handleSizeChange (val) {
      this.pagination.pageSize = val;
      this.loadData();
    },

    handleCurrentChange (val) {
      this.pagination.pageNo = val;
      this.loadData();
    },

    // ==================== 导入导出相关方法 ====================

    /**
     * 打开导入弹窗
     */
    handleImport () {
      this.importVisible = true;
    },

    /**
     * 导入成功回调
     */
    handleImportSuccess () {
      this.$message.success('导入完成');
      this.loadData();
      this.updateStatistics();
    },

    /**
     * 批量删除当前查询条件下的所有设备
     * 操作不可逆，弹窗二次确认后执行
     */
    handleBatchDelete () {
      // 组装提示信息，有筛选条件时显示具体条件，无条件时强调将删除全部
      const conditionDesc = this.buildQueryConditionDesc();
      const tipMsg = conditionDesc
        ? `将删除当前筛选条件（${conditionDesc}）下的所有设备，此操作不可恢复，确认继续？`
        : '未设置任何筛选条件，将删除全部设备，此操作不可恢复，确认继续？';

      this.$confirm(tipMsg, '批量删除确认', { type: 'warning', confirmButtonText: '确认删除', cancelButtonText: '取消', confirmButtonClass: 'el-button--danger' }).then(() => {
        this.batchDeleteLoading = true;
        deviceService.batchDeleteDevice({ ...this.queryForm }).then(res => {
          const count = res.data || 0;
          this.$message.success(`已删除 ${count} 台设备`);
          this.handleQuery();
        }).finally(() => {
          this.batchDeleteLoading = false;
        });
      }).catch(() => {});
    },

    /**
     * 将当前查询条件拼接为可读描述，用于弹窗提示
     */
    buildQueryConditionDesc () {
      const parts = [];
      if (this.queryForm.keyword) parts.push(`关键字"${this.queryForm.keyword}"`);
      if (this.queryForm.areaId) {
        const findAreaName = (nodes, id) => {
          for (const n of nodes) {
            if (n.uuid === id) return n.areaName;
            if (n.children) { const found = findAreaName(n.children, id); if (found) return found; }
          }
          return null;
        };
        const name = findAreaName(this.areaTree, this.queryForm.areaId);
        if (name) parts.push(`区域"${name}"`);
      }
      if (this.queryForm.systemId) {
        const sys = this.systemList.find(s => s.uuid === this.queryForm.systemId);
        if (sys) parts.push(`系统"${sys.systemName}"`);
      }
      if (this.queryForm.deviceTypeId) {
        const t = this.typeList.find(t => t.uuid === this.queryForm.deviceTypeId);
        if (t) parts.push(`设施类型"${t.typeName}"`);
      }
      if (this.queryForm.deviceStatus !== '') {
        parts.push(this.queryForm.deviceStatus === 0 ? '状态=正常' : '状态=故障');
      }
      if (this.queryForm.hasNfc !== '') {
        parts.push(this.queryForm.hasNfc === 'true' ? 'NFC=已绑定' : 'NFC=未绑定');
      }
      if (this.queryForm.deviceLevel) parts.push(`级别=${this.queryForm.deviceLevel}`);
      return parts.join('、');
    },

    /**
     * 导出设备数据
     */
    handleExport () {
      this.exportLoading = true;
      const params = {
        ...this.queryForm
      };
      deviceService.exportDevice(params).then(res => {
        downloadFromApiBlobResponse(res, '设备台账列表.xlsx');
        this.$message.success('导出成功');
      }).finally(() => {
        this.exportLoading = false;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.device-page {
  padding: 20px;
  background: #f5f7fa;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .stats-row {
    flex-shrink: 0;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 15px;
    margin-bottom: 10px;

    .stat-item {
      background: #fff;
      border-radius: 8px;
      padding: 18px;
      text-align: center;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }

      .stat-item-value {
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 5px;
      }

      .stat-item-label {
        font-size: 14px;
        color: #909399;
      }

      &.primary .stat-item-value { color: #2296f7; }
      &.success .stat-item-value { color: #67c23a; }
      &.danger .stat-item-value { color: #f56c6c; }
      &.warning .stat-item-value { color: #e6a23c; }
      &.purple .stat-item-value { color: #a27ce3; }
    }
  }

  .card {
    flex: 1;
    min-height: 0; /* flex 子项必须设置，否则无法被压缩 */
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    .card-header {
      flex-shrink: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      .card-title-group {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .card-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }

      .btn-group {
        display: flex;
        gap: 10px;
      }
    }

    .search-bar {
      flex-shrink: 0;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 10px;
      margin-bottom: 10px;
      padding: 10px;
      background: #f5f7fa;
      border-radius: 4px;
    }

    /* 表格填充剩余高度，内容超出时表格内部滚动 */
    .table-wrapper {
      flex: 1;
      min-height: 0;
      overflow: hidden;
    }
  }

  .pagination {
    flex-shrink: 0;
    margin-top: 20px;
    text-align: right;
  }

  // 设备级别徽章
  .level-badge {
    width: 22px;
    height: 22px;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    color: #fff;

    &.level-a { background: #f56c6c; }
    &.level-b { background: #e6a23c; }
    &.level-c { background: #b2b2b3; }
  }

  // NFC状态
  .nfc-status {
    font-size: 12px;
    &.bound { color: #67c23a; }
    &.unbound { color: #909399; }
  }

  // 安装位置
  .install-location {
    font-size: 12px;
    color: #606266;
  }

  .danger-text {
    color: #f56c6c;
  }

  .table-code-link {
    color: #2296f7;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
